export interface AIProject {
    id: string
    name: string
    summary: string
    jiraId: string
    status: string
    businessUnit: string
    stakeholders: string
    endCustomers: string[]
    solution: string
    buisinessValue: string[]
    budget: string
    expectedBenefits: string
    dataInputs: string
    output: string
    successCriteria: string
    problemStatement: string
    jiraURL: string
    confluenceURL: string
    requestorName: string
    stakeholderNames: string[]
    notes: string
    rationale: string
    teamsURL: string
}

export interface LinkedRecord {
    id: string
    value: string
}

export enum CellType {
    Text,
    List,
    Number,
    Select,
    MultiSelect
}

export interface CanvasCell {
    type: CellType
    fieldName: string
    value: CellValue
    icon: React.ReactNode
}

export type CellValue = string | string[] | number | LinkedRecord | undefined

// these are the strings that are used to reference the fields in airtable
// this is also what shows up in the front-end headers
export enum CellField {
    Blank = "Blank",
    ProblemStatement = "Problem Statement",
    Summary = "Summary",
    JiraID = "Jira ID",
    Stakeholders = "Stakeholders",
    EndCustomers = "End Customers",
    SolutionCallToAction = "Solution",
    BusinessValue = "Business Value",
    Budget = "Budget",
    ExpectedBenefits = "Annual Expected Benefits",
    DataInputs = "Data Inputs",
    OutputIntegration = "Output/Integration",
    SuccessCriteria = "Success Criteria",
    Project = "Project",
    Status = "Status",
    BU = "BU",
    Notes = "Notes",
    Rationale = "Value Proposition",
    RequestorName = "Requestor Name",
}

export interface FieldDescriptions {
    [key: string]: string;
  }